import { CircularProgress, MenuItem, Select, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputContainer from "../../../components/InputContainer";
import { listInteractiveAction } from "../../../store/actions/interactive";

const LivePoll = ({ formik }) => {
  const dispatch = useDispatch();

  const interactive = useSelector((s) => s.interactive.list);
  const loading = useSelector((s) => s.interactive.loading);
  const thisPage = useSelector((s) => s.interactive.thisPage);
  const allPages = useSelector((s) => s.interactive.allPages);

  const fetchInteractive = useCallback(
    ({ page }) => {
      listInteractiveAction({
        page,
        limit: 10,
        type: "chatBot",
      })(dispatch);
    },
    [dispatch]
  );

  const onScroll = useCallback(
    (e) => {
      if (loading) return;
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (
        scrollTop + clientHeight + 50 >= scrollHeight &&
        allPages !== thisPage
      ) {
        fetchInteractive({ page: thisPage + 1 });
      }
    },
    [allPages, loading, thisPage, fetchInteractive]
  );

  useEffect(() => {
    fetchInteractive({ page: 1 });
  }, []);
  return (
    <>
      <InputContainer title={"Live Poll"} sx={{ my: 1 }}>
        <Select
          fullWidth
          size="small"
          variant="standard"
          id="entityId"
          name="entityId"
          value={formik.values.entityId}
          MenuProps={{
            PaperProps: {
              onScroll: onScroll,
              sx: { maxHeight: "300px" },
            },
          }}
          renderValue={
            formik.values.entityId !== ""
              ? undefined
              : () => (
                  <Typography variant="subtitle1" color="text.disabled">
                    choose Live Poll
                  </Typography>
                )
          }
          displayEmpty
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={formik.touched.entityId && Boolean(formik.errors.entityId)}
          helperText={formik.touched.entityId && formik.errors.entityId}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "2px solid #F6F6F6",
            },
            backgroundColor: "white",
          }}
        >
          {interactive?.length > 0 &&
            interactive?.map((e, i) => {
              return (
                <MenuItem key={i} value={e?.id}>
                  {e?.name}
                </MenuItem>
              );
            })}

          {loading && (
            <MenuItem>
              <CircularProgress size={20} sx={{ margin: "auto" }} />
            </MenuItem>
          )}
        </Select>
      </InputContainer>
    </>
  );
};

export default LivePoll;
